import asyncRoute from '../AsyncRoute'

export function getComponent ({store}) {
  return new Promise((resolve) => {
    require.ensure([], (require) => {
      const View = require('hfty-reports-dom').Reports
      resolve(View)
    }, 'hfty-reports-dom')
  })
}

export default asyncRoute({getComponent, reducers: []})
